<template>
    <cms-block v-bind="$props" @block-selected="selectBlock">
        <cms-component-image comp-id="image" :component="block.image" v-bind="componentProps"/>
        <cms-component-glyph comp-id="glyph" :component="block.glyph" v-bind="componentProps"/>
        <cms-component-text comp-id="text" :component="block.text" placeholder="Text|Texte" v-bind="componentProps"/>
    </cms-block>
</template>

<script>
import CmsBlockRenderer from "@components/editor/rendering/blocks/cms-block-renderer.vue";
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";
import CmsComponentImage from "@components/editor/rendering/components/cms-component-image.vue";
import CmsComponentText from "@components/editor/rendering/components/cms-component-text.vue";
import CmsComponentGlyph from "@components/editor/rendering/components/cms-component-glyph.vue";

export default {
    name: `cms-block-table-cell`,
    components: {
        CmsComponentGlyph,
        CmsComponentText,
        CmsComponentImage,
        CmsBlockRenderer,
        CmsBlock
    },
    extends: CmsBlock,
    props: {
        column: {type: Object, required: true}
    }
}
</script>

<style lang="scss" scoped>
</style>
